<mat-button-toggle-group class="st-manage-team-members-main-cta-button-group">
    <mat-button-toggle
        class="st-manage-team-members-button-new-member"
        (click)="openNewMemberDialog()">
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        {{ languageSettings.PSTWebNewMemberLabel }}
    </mat-button-toggle>
</mat-button-toggle-group>
